import { render, staticRenderFns } from "./SeatSelectPassenger.vue?vue&type=template&id=2c90c5a7&scoped=true&"
import script from "./SeatSelectPassenger.vue?vue&type=script&lang=js&"
export * from "./SeatSelectPassenger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c90c5a7",
  null
  
)

export default component.exports